import CryptoJS from "crypto-js";
const { REACT_APP_ENCRYPT_REQUEST_SECRET_KEY, REACT_APP_ENABLE_ENCRYPTION } =
  process.env;

function encryptRequest(data, isString = false) {
  if (!+REACT_APP_ENABLE_ENCRYPTION) return data;
  const encryptedData = CryptoJS.AES.encrypt(
    isString ? data : JSON.stringify(data),
    REACT_APP_ENCRYPT_REQUEST_SECRET_KEY
  ).toString();

  return encryptedData;
}

function decryptRequest(encryptedData, isString = false) {
  if (!+REACT_APP_ENABLE_ENCRYPTION) return encryptedData;
  const decryptedBytes = CryptoJS.AES.decrypt(
    encryptedData,
    REACT_APP_ENCRYPT_REQUEST_SECRET_KEY
  );
  const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
  return isString ? decryptedData : JSON.parse(decryptedData);
}

export { encryptRequest, decryptRequest };
